import React, { Component } from "react"
import PropTypes from "prop-types"
import Logo from "./../../images/logo.png"
import Hamburger from "./../../images/navbar/hamburger.png"
import Search from "./../../images/navbar/search.png"
import { Locale } from "../locale"
import { MobileMenu } from "./mobile-menu"
import "./index.scss"
import { AppLink } from "../appLink"
import { CookiesBar } from "../cookiesBar"
import { getCookiesConfigObject } from "../../utils/graphqlUtils"

const headerHeight = 80

export default class Navbar extends Component {

  constructor(props) {
    super()
    this.state = {
      menuOpen: false,
      scrollPos: 0,
      show: true
    }

    this.openMenu = this.openMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.getContainerClasses = this.getContainerClasses.bind(this)
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.onscroll = this.handleScroll
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.onscroll = null
    }
  }

  openMenu() {
    this.setState(old => ({ ...old, menuOpen: true }))
    if (typeof document !== "undefined") {
      document.body.style.overflow = "hidden"
    }
  };

  closeMenu() {
    this.setState(old => ({ ...old, menuOpen: false }))

    if (typeof document !== "undefined") {
      document.body.style.overflow = "unset"
    }
  };

  handleScroll(e) {
    const { scrollPos } = this.state
    const { top } = document.body.getBoundingClientRect()
    const show = Boolean((top > scrollPos) || top > -(headerHeight))

    this.setState(old => {
        return {
          ...old,
          scrollPos: top,
          show: show
        }
      }
    )
    this.forceUpdate()
  };

  getContainerClasses() {
    const classes = ["app-navbar"]
    if (this.state.menuOpen) {
      classes.push("gradient")
    }
    if (!this.state.menuOpen) {
      classes.push("overflow-hidden")
    }
    if (this.state.scrollPos < -headerHeight) {
      classes.push("pink-background")
    }
    if (!this.state.show) {
      classes.push("d-none")
    }
    return classes.join(" ")
  }


  render() {
    return (
      <div>
        <div
          className={this.getContainerClasses()}
          aria-label="main-navigation"
        >
          <CookiesBar data={getCookiesConfigObject(this.props.data)}/>
          <div className="navbar-cols-container container d-flex p-sm-0">
            <div className="col p-0 d-flex align-items-center">
              {/*{!this.state.menuOpen && <Locale {...this.props} />}*/}
              <Locale {...this.props} />
            </div>
            <div className="logo-container col-auto p-0 d-flex justify-content-center align-items-center">
              <AppLink to="/" onClick={this.closeMenu} pageContext={this.props.pageContext}>
                <img src={Logo} className="img-fluid" alt="logo"/>
              </AppLink>
            </div>
            <div className="search-hamburger col p-0 d-flex justify-content-end align-items-center">
              <div className="sh-col">
                {!this.state.menuOpen && <button onClick={this.openMenu}>
                  <img src={Hamburger} alt="menu-button"/>
                </button>}
              </div>
            </div>
          </div>
          <MobileMenu {...this.props} closeMenu={this.closeMenu} isOpen={this.state.menuOpen} menuObject={this.props.menuObject}/>
          {this.props.children}
        </div>
        {/*<div className="app-navbar-placeholder"/>*/}
      </div>

    )
  }
};

Navbar.propTypes = {
  menuObject: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}


